import { BrandLoader } from './BrandLoader';

/**
 * The three things a chart shows when it isn't showing data.
 *
 * Refetch is deliberately NOT one of them: when a chart already has a render and
 * the params change, `ChartRenderer` holds the old pixels at reduced opacity
 * rather than swapping in a skeleton. A skeleton on every filter change makes a
 * dashboard flash and jump, and the reader loses their place.
 */

export const Empty = ({ message = 'No data for this selection' }: { message?: string }) => (
  <div className="chart-state chart-state--empty">
    <span>{message}</span>
  </div>
);

/**
 * `size` exists because a dashboard tile and a full-page report are very
 * different amounts of room — the mark should not dominate a small widget.
 */
export const ChartLoading = ({ label = 'Loading', size = 48 }: { label?: string; size?: number }) => (
  <div className="chart-state chart-state--loading">
    <BrandLoader size={size} label={label} />
  </div>
);

interface ErrorProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export const ChartError = ({ title = 'Chart unavailable', message, onRetry }: ErrorProps) => (
  <div className="chart-state chart-state--error" role="alert">
    <strong>{title}</strong>
    <span>{message}</span>
    {onRetry && (
      <button type="button" className="ghost" onClick={onRetry}>
        Try again
      </button>
    )}
  </div>
);
